import {Loader} from '@mantine/core';
import {isReleasedRedesignRecruitment} from '../../../../config/unReleasePage';
import {useGetRelatedCompanyRecruitmentList} from '../../../../core/repositories/recruitmentRepository';
import {RecruitmentItemForDetail} from '../Container/Presenter/RecuritmentItemForDetail';
import {RecruitmentList} from './RecruitmentList';

export const RelatedCompanyRecruitmentList: React.FC<{
  companyId: number;
  companyName: string;
}> = ({companyId, companyName}) => {
  const {data, isLoading} = useGetRelatedCompanyRecruitmentList({
    companyID: companyId,
  });

  if (isReleasedRedesignRecruitment()) {
    const recruitments = data?.ok
      ? data.value.flatMap((relatedCompany) => relatedCompany.recruitments)
      : [];
    return (
      <RecruitmentList
        title={`${companyName}の関連企業の募集情報`}
        recruitments={recruitments}
      />
    );
  }

  return isLoading ? (
    <div className="w-full h-[150px] flex justify-center items-center">
      <Loader color="gray" />
    </div>
  ) : (
    data?.ok && data.value.length > 0 && (
      <div className="mt-16">
        <h2 className="bg-primary-1 p-12 text-white text-md leading font-bold">
          {companyName}の関連企業の募集情報
        </h2>
        <div className="bg-white p-16">
          <h3 className="bg-background-1 p-8 text-md text-black leading font-bold">
            募集情報
          </h3>
          <div className="bg-white mt-12">
            {data.value.map((relatedCompany) =>
              relatedCompany.recruitments.map((recruitment) => (
                <RecruitmentItemForDetail recruitment={recruitment} />
              )),
            )}
          </div>
        </div>
      </div>
    )
  );
};
